export function getModelRunResponses(model) {
  return {
    success: {
      success: true,
      data: {
        image_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
        status: "processing",
      },
    },
    error: {
      success: false,
      error: {
        message: "Missing required parameter: model_id",
        code: "VALIDATION_ERROR",
      },
    },
    webhook_success: {
      image_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      model_id: model.model_id,
      status: "completed",
      input_texts: {
        input_text: "Your prompt text",
        negative_prompt: null,
        positive_prompt: "Your prompt text",
      },
      input_images: {
        input_image: null,
        mask_image_url: null,
        seed_image_url: null,
      },
      cost_to_client: model.average_cost ? Number(model.average_cost) : 0.005,
      created_at: "2025-01-01T00:00:00.000Z",
      processing_at: "2025-01-01T00:00:00.100Z",
      completed_at: "2025-01-01T00:00:05.000Z",
      model_name: model.model_name,
      input_params: {},
      duration: "5.00000000",
      results: [
        {
          image_id: "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",
          external_url: "https://example.com/image/result.jpg",
          content_type: "image",
          content: "https://example.com/image/result.jpg",
        },
      ],
      success: true,
    },
    webhook_error: {
      image_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      error: {
        message: "Invalid parameter value",
        parameter: "positivePrompt",
        type: "string",
        min: 2,
        max: 3000,
      },
      success: false,
    },
  };
}

export function getModelJobResponses(model) {
  return {
    success: {
      success: true,
      data: {
        image_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
        model_id: model.model_id,
        status: "completed",
        input_texts: {
          input_text: "Your prompt text",
          negative_prompt: null,
          positive_prompt: "Your prompt text",
        },
        input_images: {
          input_image: null,
          mask_image_url: null,
          seed_image_url: null,
        },
        cost_to_client: model.average_cost ? Number(model.average_cost) : 0.005,
        created_at: "2025-01-01T00:00:00.000Z",
        processing_at: "2025-01-01T00:00:00.100Z",
        completed_at: "2025-01-01T00:00:05.000Z",
        failed_at: null,
        model_name: model.model_name,
        duration: "5.00000000",
        results: [
          {
            image_id: "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",
            external_url: "https://example.com/image/result.jpg",
            content_type: "image",
            content: "https://example.com/image/result.jpg",
          },
        ],
      },
    },
  };
}

export function getWorkflowRunResponses(workflow) {
  return {
    success: {
      success: true,
      data: {
        workflow_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
        status: "processing",
      },
    },
    error: {
      success: false,
      error: {
        message: "Missing required parameter: prompt",
        code: "VALIDATION_ERROR",
      },
    },
    webhook_success: {
      workflow_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      workflow_definition_id: workflow.workflow_definition_id,
      input_params: {},
      input_texts: {
        input_text: null,
        negative_prompt: null,
        positive_prompt: null,
      },
      input_images: {
        input_image: null,
        mask_image_url: null,
        seed_image_url: null,
      },
      results: {
        results: [
          {
            image_id: "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",
            external_url: "https://example.com/image/result.jpg",
            content_type: "image",
            content: "https://example.com/image/result.jpg",
          },
        ],
      },
      status: "completed",
      cost_to_client: workflow.average_cost ? Number(workflow.average_cost) : 0.05,
      created_at: "2025-01-01T00:00:00.000Z",
      processing_at: "2025-01-01T00:00:00.100Z",
      completed_at: "2025-01-01T00:00:12.000Z",
      client_id: "your-client-id",
      workflow_definition_name: workflow.name,
    },
    webhook_error: {
      workflow_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
      error: "Error message describing what went wrong",
      success: false,
    },
  };
}

export function getWorkflowJobResponses(workflow) {
  return {
    success: {
      success: true,
      data: {
        workflow_job_id: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
        workflow_definition_id: workflow.workflow_definition_id,
        input_params: {},
        status: "completed",
        cost_to_client: workflow.average_cost ? Number(workflow.average_cost) : 0.05,
        created_at: "2025-01-01T00:00:00.000Z",
        processing_at: "2025-01-01T00:00:00.100Z",
        completed_at: "2025-01-01T00:00:12.000Z",
        failed_at: null,
        client_id: "your-client-id",
        workflow_definition_name: workflow.name,
        num_of_steps: 4,
        num_of_completed_steps: 4,
        results: {
          results: [
            {
              content: "https://example.com/image/result.jpg",
              image_id: "yyyyyyyy-yyyy-yyyy-yyyy-yyyyyyyyyyyy",
              content_type: "image",
              external_url: "https://example.com/image/result.jpg",
            },
          ],
        },
      },
    },
  };
}
